Flickity.prototype._touchActionValue = 'pan-y pinch-zoom';
jQuery(function ($) {
    function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };
    const carousel = $('.main-carousel-singular');
    carousel.flickity({
        // options
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        setGallerySize: false,
        percentPosition: true,
        pageDots: false,
        prevNextButtons: false,
        fade: true,
        selectedAttraction: 1,
        friction: 1,
        imagesLoaded: true,
        // adaptiveHeight: true
    });

    var flkty = carousel.data('flickity');
    // carousel.on( 'select.flickity', function() { $(this).flickity('playPlayer') })
    carousel.on('click', function () {
        carousel.flickity('next')
        change_content()
        var cell = flkty.selectedIndex + 1
        $('.cell-number').html(cell)
        // carousel.flickity('playPlayer')
    })
    $('.left-arrow').on('click', function () {
        carousel.flickity('previous')
        var cell = flkty.selectedIndex + 1
        $('.cell-number').html(cell)
    })
    $('.right-arrow').on('click', function () {
        carousel.flickity('next')
        var cell = flkty.selectedIndex + 1
        $('.cell-number').html(cell)
    })

    change_content()
    function change_content(){

        // Content
        var cell_data = carousel.find('.is-selected').data('content');
        console.log(cell_data)
        if (cell_data != "") {
            $('.bild-text').html(cell_data)
        } else {
            $('.bild-text').html("")  
        }
    }
    
    function resizeMainSingular() {
        var windowHeight = $(window).height()
        var windowWidth = $(window).width()
        var headerHeight = $('.nav-mobile-singular').outerHeight()
        var numberHeight = $('.number').outerHeight()

        var op = windowHeight - headerHeight
        console.log(headerHeight)
        if (isMobileDevice()) {
            
            if (windowWidth >= 900) {
                
                $('#works-singular-main').css({ 'height': windowHeight })
            } else {
                
                $('#works-singular-main').css({ 'height': op })
            }
        } else {
            
            $('#works-singular-main').css({'height': ''})
        } 
    }
    resizeMainSingular()
    $(window).on('resize', function () {
        resizeMainSingular()
    })
    $(window).on('load', function () { 
        
    })

    //* Logo Click
    $('.footer-logo').on('click', function () {

        
        window.location.href = home.url
        
    })
})